export default "__VITE_ASSET__BkR7Q$gV__"